




















































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import util from "@/lib/util";
class CreateTimeType {
  startTime: string = "";
  endTime: string = "";
}
@Component({
  components: {},
})
export default class SelectedModal extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: 0 }) modelValue: number;

  createTime: CreateTimeType = new CreateTimeType();
  id: number = 0;
  title: string = "选择预订须知";
  content: string = "";
  selectedId: number = 0;
  selectContent(articleId) {
    if (articleId > 0) {
      let article = this.list.find((article) => {
        return article.id == articleId;
      });
      this.content = article.body;
    }
  }
  save() {
    if (this.selectedId > 0 && this.content) {
      this.$emit("input", false);
      let data = {
        content: this.content,
        modelValue: this.modelValue,
      };
      this.$emit("save-success", encodeURIComponent(JSON.stringify(data)));
    } else {
      this.$Message.error({
        content: "请选择模板",
      });
    }
  }
  get list() {
    return this.$store.state.article.list;
  }
  cancel() {
    this.$emit("input", false);
  }

  async getArticleList(articleCategoryId) {
    await this.$store.dispatch({
      type: "article/getAll",
      data: {
        ArticleCategoryId: articleCategoryId,
        SkipCount: 0,
        MaxResultCount: 10000,
      },
    });
  }

  async visibleChange(value: boolean) {
    if (!value) {
      this.id = 0;
      this.$emit("input", value);
      this.title = "选择预订须知";
      this.content='';
    } else {
      if (this.$props.modelValue) {
        let articleCategoryId = this.$props.modelValue == 1 ? 3 : 4;
        this.title =
        this.$props.modelValue == 1 ? "选择预订须知" : "选择取消预订须知";
        this.getArticleList(articleCategoryId);
      } else {
        this.$Message.error({
          content: "遇到未知错误",
        });
      }
    }
  }
}
